/* eslint-disable react/display-name */
import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

const LogPage = lazy(() => import("./pages/log"));
const DvrPage = lazy(() => import("./pages/dvr"));
const ConfigPage = lazy(() => import("./pages/config"));
const CheckAttendancePage = lazy(() => import("./pages/check-attendance"));
const CheckSecurityAttendancePage = lazy(
  () => import("./pages/check-security-attendance")
);
const CheckSecurityCleaningPage = lazy(
  () => import("./pages/check-security-cleaning")
);
const CheckingPage = lazy(() => import("./pages/checking"));
const TruckCameraManagePage = lazy(() => import("./pages/truck-camera-manage"));
const RentalTruckCameraManagePage = lazy(
  () => import("./pages/rental-truck-camera-manage")
);
const CameraPermission = lazy(() => import("./pages/permission"));
const CameraActionConfigManagePage = lazy(
  () => import("./pages/action-manage")
);
const CameraLivesPage = lazy(() => import("./pages/lives"));
const CameraPlaybackPage = lazy(() => import("./pages/playback"));
const DvrStatisticsPage = lazy(() => import("./pages/dvr-statistics"));
const StationStatisticPage = lazy(() => import("./pages/station-statistics"));
const UserLogManagePage = lazy(() => import("./pages/user-log-manage"));
const BagOrderPage = lazy(() => import("./pages/bag-order"));
const BoxOrderPage = lazy(() => import("./pages/green-box"));
const BagLogPage = lazy(() => import("./pages/bag-log"));
const StationCameraPage = lazy(() => import("./pages/station-camera"));
const VideoJobPage = lazy(() => import("./pages/video-job"));
const VerifyImageOrder = lazy(() => import("./pages/verify-image-order"));
const ConveyorCameraConfig = lazy(
  () => import("./pages/conveyor-camera-config")
);
const ConveyorCameraLog = lazy(() => import("./pages/conveyor-camera-log"));
const CameraCaptureConfigPage = lazy(
  () => import("./pages/camera-capture-config")
);
const CameraBlockConfigPage = lazy(() => import("./pages/camera-block-config"));

// CameraAI
const CameraAIManagePage = lazy(() => import("./pages/camera-ai-managex"));
const CameraAIFirmwarePage = lazy(() => import("./pages/camera-ai-firmware"));
const CameraAIModelPage = lazy(() => import("./pages/camera-ai-model"));
const CameraAILogPage = lazy(() => import("./pages/camera-ai-logex"));
const CameraAIUserPage = lazy(() => import("./pages/camera-ai-user"));
const UserCameraPermissionPage = lazy(
  () => import("./pages/user-camera-permission")
);

// Camera Xe tải
const TruckCameraMonitoringPage = lazy(
  () => import("../truck/pages/truck-camera-monitoring")
);
const TruckCameraLogPage = lazy(
  () => import("../truck/pages/truck-camera-log")
);
const TruckCameraLogDayPage = lazy(
  () => import("../truck/pages/truck-during-day")
);

// Hệ thống
const ServerPage = lazy(() => import("./pages/server"));
// const StationManagementPage = lazy(() => import("./pages/station-management"));
// const UserPermissionPage = lazy(() => import("./pages/user-permission"));

const CameraSettingPage = lazy(() => import("./pages/setting"));
const DvrUserPage = lazy(() => import("./pages/dvr-user"));
const DvrChannelPage = lazy(() => import("./pages/dvr-channel"));

// Quản lý camera smartlock
const CameraSmartLockPage = lazy(() => import("./pages/camera-smartlock"));
// Giám sát camera xe tải V2
const TruckCameraMonitoringV2Page = lazy(
  () => import("../truck/pages/truck-camera-monitoring/TruckCameraMonitorV2")
);
const DvrCameraProfilePage = lazy(() => import("./pages/dvr-profile"));
const LegoProfile = lazy(() => import("./pages/lego-profile"));
const TruBuuCucProfile = lazy(() => import("./pages/truBuuCuc-profile"));

const FaceRecognitionPage = lazy(() => import("./pages/face-recognition"));
const TruckCameraStatisticPage = lazy(
  () => import("./pages/truck-statistic-report")
);

const CameraInspectionScenarios = lazy(
  () => import("./pages/camera-inspection-scenarios")
);

const CameraOperationalInspections = lazy(
  () => import("./pages/camera-operational-inspections")
);

const CameraInspectionsReport = lazy(
  () => import("./pages/camera-inspection-report")
);

const CameraTagConfigsPage = lazy(() => import("./pages/camera-tag-configs"));
const UserTagPermissionPage = lazy(() => import("./pages/user-tag-permission"));
const TruckCameraPermissionPage = lazy(
  () => import("./pages/truck-camera-permission")
);
const UpdatePublicIpPage = lazy(() => import("./pages/update-public-ip"));
const DownloadHistoryPage = lazy(() => import("./pages/download-history"));
const ShareUrlPage = lazy(() => import("./pages/share-url"));

const CameraRoutes = [
  { path: "station", element: <StationCameraPage /> },
  { path: "log", element: <LogPage /> },
  { path: "dvr", element: <DvrPage /> },
  { path: "config", element: <ConfigPage /> },
  { path: "conveyor-camera-config", element: <ConveyorCameraConfig /> },
  { path: "conveyor-camera-log", element: <ConveyorCameraLog /> },
  { path: "checking", element: <CheckingPage /> },
  { path: "check-attendance", element: <CheckAttendancePage /> },
  {
    path: "check-security-attendance",
    element: <CheckSecurityAttendancePage />
  },
  { path: "bag-order", element: <BagOrderPage /> },
  { path: "green-box", element: <BoxOrderPage /> },
  { path: "camera-manage", element: <TruckCameraManagePage /> },
  { path: "rental-camera-manage", element: <RentalTruckCameraManagePage /> },
  {
    path: "camera-config-action-manage",
    element: <CameraActionConfigManagePage />
  },
  { path: "statistics/station", element: <StationStatisticPage /> },
  { path: "verify-image-order", element: <VerifyImageOrder /> },
  { path: "statistics/bag-log", element: <BagLogPage /> },
  { path: "lives", element: <CameraLivesPage /> },
  { path: "playback", element: <CameraPlaybackPage /> },
  { path: "camera-permission", element: <CameraPermission /> },
  { path: "user-camera-permission", element: <UserCameraPermissionPage /> },
  { path: "statistics/dvr", element: <DvrStatisticsPage /> },
  { path: "user-logs", element: <UserLogManagePage /> },
  { path: "video-job", element: <VideoJobPage /> },
  { path: "ai/camera-manage", element: <CameraAIManagePage /> },
  { path: "ai/firmware", element: <CameraAIFirmwarePage /> },
  { path: "ai/model", element: <CameraAIModelPage /> },
  { path: "ai/log", element: <CameraAILogPage /> },
  { path: "ai/user-detection", element: <CameraAIUserPage /> },
  { path: "check-security-cleaning", element: <CheckSecurityCleaningPage /> },
  { path: "system/server", element: <ServerPage /> },
  { path: "system/setting", element: <CameraSettingPage /> },
  { path: "system/dvr-user", element: <DvrUserPage /> },
  { path: "system/dvr-channel", element: <DvrChannelPage /> },
  { path: "camera-truck-monitoring", element: <TruckCameraMonitoringPage /> },
  { path: "camera-truck-log", element: <TruckCameraLogPage /> },
  { path: "camera-during-day", element: <TruckCameraLogDayPage /> },
  { path: "camera-smartlock", element: <CameraSmartLockPage /> },
  { path: "camera-monitor-truck", element: <TruckCameraMonitoringV2Page /> },
  { path: "dvr-profile", element: <DvrCameraProfilePage /> },
  { path: "lego-profile", element: <LegoProfile /> },
  { path: "trubc-profile", element: <TruBuuCucProfile /> },
  { path: "face-recognition", element: <FaceRecognitionPage /> },
  { path: "camera-capture-configs", element: <CameraCaptureConfigPage /> },
  { path: "camera-block-configs", element: <CameraBlockConfigPage /> },
  { path: "truck-statistic-report", element: <TruckCameraStatisticPage /> },
  {
    path: "camera-inspection-scenarios",
    element: <CameraInspectionScenarios />
  },
  {
    path: "operational-inspections",
    element: <CameraOperationalInspections />
  },
  { path: "report/inspections-report", element: <CameraInspectionsReport /> },
  { path: "camera-tag-configs", element: <CameraTagConfigsPage /> },
  { path: "user-tag-permission", element: <UserTagPermissionPage /> },
  { path: "update-public-ip", element: <UpdatePublicIpPage /> },
  { path: "truck-camera-permission", element: <TruckCameraPermissionPage /> },
  { path: "download-history", element: <DownloadHistoryPage /> },
  { path: "share-url/:id", element: <ShareUrlPage /> },

  // Redirect
  { path: "*", element: <Navigate to="/camera/checking" /> }
];
export default CameraRoutes;
